import React from 'react';
import { Translate } from 'react-localize-redux';
import styled, { withTheme } from 'styled-components';

import { StyledLink } from './item';

const Title = styled.div`
  font-size: 1.1em;
  line-height: 1.25;
`;

const Span = styled.span`
  display: inline-block;
  margin-right: 0.25em;
`;

const Game = ({ theme, name, ...rest }) => {
  return (
    <StyledLink
      {...rest}
      activeStyle={{
        background: theme.primary
      }}
    >
      <Title>
        <Translate>
          {({ translate }) =>
            translate(`menu.${name}.title`)
              .split(' ')
              .map((text, index) => <Span key={index}>{text}</Span>)
          }
        </Translate>
      </Title>
    </StyledLink>
  );
};

export default withTheme(Game);
